import { useNavigate } from '@tanstack/react-router';
import { classNames } from '../../style/classNames';

interface TerminalScreenMessageProps {
  onReturnToOverview?: () => void;
}

export default function TerminalScreenMessage({ onReturnToOverview }: TerminalScreenMessageProps) {
  const navigate = useNavigate();
  return (
    <div className="mt-4 flex flex-col items-center gap-3">
      <p className="text-center text-lg">
        You have completed all available sections. Tap below to return to your overview.
      </p>
      <button
        id="return-home-button"
        onClick={onReturnToOverview ?? (() => navigate({ to: '/' }))}
        className={classNames.nextButton}
      >
        Return to Overview
      </button>
    </div>
  );
}
